import React, { useEffect, useState } from "react";
// constants
import { BANK_DATA, BANK_TYPE } from "../../../constants/BANK_DATA";
// apis
import { getConstantsCbks, getConstantsPbks } from "../../../apis/code";
import { deleteFinancesAccounts, getFinancesAccounts, modifyFinancesScraping } from "../../../apis/finances/auth";
// components
import FinancialTable from "../../../components/Table/FinancialTable";
import Icon from "../../../components/Icon";
import Guide from "../../../components/Guide";
import Badge from "../../../components/Badge";
// page
import BankAccount from "./Component/BankAccout";
import NickName from "./Component/NickNameModal";
// utils
import { flatten, forEach, get, isEmpty } from "lodash";
import { translation } from "../../../utils/translator";
import { viewLoading } from "../../../utils/loading";
import systemAlert from "../../../utils/systemAlert";
import { accountName } from "../../../utils/account-name";
// image
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png"
import { FINANCE_SCRAPING_STATE } from "../../../constants/SCRAPING_DATA";

const BankAccountMapping = ({ permission }) => {
  const [fields] = useState([
    {
      key: "bankCd",
      className: "finance-name",
      onValue: (value, field, data) => {
        const { bankCompany, bankImg, acctNo, bankType, nickName } = data
        return (
          <>
            <div style={ data.isUsing ? {} : {opacity: 0.5}}>
              <Icon className="bank-img-wrap" src={bankImg || defaultBankImage} alt={bankCompany} />
              <Badge
                className="margin-left-8"
                color={bankType === 'pbk' ? "secondary" : 'warning'}
                size="sm"
                label={translation(BANK_TYPE, bankType)}
              />
              <span className="margin-left-8">
                {accountName(bankCompany, acctNo, nickName)}
              </span>
            </div>
          </>
        );
      },
    },
    {
      key: "acctNm",
      className: "finance-description",
      onValue: (value, field, data) => {
        const target = FINANCE_SCRAPING_STATE.find(state => state.value === data.state) || {}
        return (
          <div className="nowrap" style={ data.isUsing ? {} : {opacity: 0.5}}>
            <span>{value}</span>
            {!isEmpty(target) && (
              <Badge
                className="margin-left-8"
                color={target.color}
                size="sm"
                label={target.label}
              />
            )}
          </div>
        )
      }
    },
  ]);
  const [status, setStatus] = useState({
    use: 0,
    normal: 0,
    error: 0,
  });
  const [list, setList] = useState([]);
  const [pbkList, setPbkList] = useState([]);
  const [cbkList, setCbkList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // 연동 모달
  const [connectOpen, setConnectOpen] = useState(false);
  const [connectMode, setConnectMode] = useState('create')
  const [connectData, setConnectData] = useState({})
  const [originBankData, setOriginBankData] = useState([])

  // nickname 모달
  const [detailOpen, setDetailOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formMode, setFormMode] = useState('create')

  useEffect(() => {
    submit();
  }, []);

  useEffect(() => {
    if (!isEmpty(list)) {
      let use = 0;
      let normal = 0;
      let error = 0;
      forEach(list, account => {
        if (account.isUsing === 1) use++
        if (account.state === 1 || account.state === 9) normal++
        if (account.state === 2) error++
      })

      setStatus({
        use,
        normal,
        error
      })
    }
  }, [list])

  useEffect(() => {
    setList([...pbkList, ...cbkList]);
  }, [pbkList, cbkList]);

  const submit = () => {
    let count = 0;
    setIsLoading(true);
    // 개인뱅킹
    getConstantsPbks().then((res) => {
      const pbkCodes = res.data.pbks;
      getFinancesAccounts("pbk")
        .then((res) => {
          count++;
          const bankData = get(res, "data.accounts", []);
          setOriginBankData(s => [...s, ...bankData])
          if (isEmpty(bankData)) return setPbkList([]);
          setPbkList(
            flatten(bankData.map(({ financeScrapings, ...bank }) =>
              (financeScrapings || []).map((finance) => ({
                ...finance,
                bankType: 'pbk',
                bankCompany:
                  translation(pbkCodes, bank.bankCd, "code", "name"),
                bankImg: translation(
                  BANK_DATA,
                  bank.bankCd,
                  "fcode",
                  "bankImg"
                ),
              }))))
          );
        })
        .finally(() => {
          if (count >= 2) {
            setIsLoading(false);
          }
        });
    });
    // 법인뱅킹
    getConstantsCbks().then((res) => {
      const cbkCodes = res.data.cbks;
      getFinancesAccounts("cbk")
        .then((res) => {
          count++;
          const bankData = get(res, "data.accounts", []);
          setOriginBankData(s => [...s, ...bankData])
          if (isEmpty(bankData)) return setCbkList([]);
          setCbkList(
            flatten(bankData.map(({ financeScrapings, ...bank }) =>
              (financeScrapings || []).map((finance) => ({
                ...finance,
                bankType: 'cbk',
                bankCompany:
                  translation(cbkCodes, bank.bankCd, "code", "name"),
                bankImg: translation(
                  BANK_DATA,
                  bank.bankCd,
                  "fcode",
                  "bankImg"
                ),
              }))))
          );
        })
        .finally(() => {
          if (count >= 2) {
            setIsLoading(false);
          }
        });
    });
  };

  const setUsingAction = (checked, idx) => {
    const formData = {
      isUsing: checked ? 1 : 0,
      isScrap: checked ? 1 : 0,
    }
    viewLoading(true)
    modifyFinancesScraping(idx, formData).then((res) => {
      submit();
    }).catch(() => { }).finally(() => {
      viewLoading(false)
    })
  }

  const setScrapAction = (checked, idx) => {
    const formData = {
      isScrap: checked ? 1 : 0
    }
    viewLoading(true)
    modifyFinancesScraping(idx, formData).then((res) => {
      submit();
    }).catch(() => { }).finally(() => {
      viewLoading(false)
    })
  }

  const headerbutton = [
    {
      label: "새 은행계좌 연동",
      color: "line",
      size: "sm",
      action: () => {
        setConnectOpen(true);
        setConnectMode('create');
      },
      className: "float-right",
    },
  ];

  const controller = {
    rowButtons: [
      {
        isHide: !(permission.level > 1),
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          systemAlert(
            <div>
              <Guide
                color='red'
                children={<>해당 인증정보의 모든 은행정보가 삭제됩니다.</>} />
              <p className="margin-top-10">인증정보를 삭제하시겠습니까?</p>
            </div>, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true)
                  deleteFinancesAccounts(data.financeAccountIdx).then(() => { submit() }).catch(() => { }).finally(() => viewLoading(false))
                }
              }
            ]
          })
        },
      },
      {
        isHide: !(permission.level > 1),
        label: "수정",
        type: "edit",
        action: (data) => {
          const financeData = originBankData.find((bank) => bank.idx === data.financeAccountIdx)
          setConnectOpen(true);
          setConnectData(financeData);
          setConnectMode('modify');
        },
      },
      {
        isHide: !(permission.level > 1),
        label: "별칭",
        type: "nickname",
        action: (data) => {
          setFormData({...data});
          setDetailOpen(true);
          setFormMode('modify')
        },
      },
    ],
    setUsingAction,
    setScrapAction,
    switchDisabled: !(permission.level > 1),
  }

  useEffect(() => {
    if (!connectOpen) {
      setConnectMode('create')
    }
  }, [connectOpen])

  return (
    <>
      <FinancialTable
        title="은행계좌 연동하기"
        fields={fields}
        list={list}
        isLoading={isLoading}
        status={status}
        buttons={permission.level > 1 ? headerbutton : []}
        controller={controller}
      />
      <BankAccount
        open={connectOpen}
        setOpen={setConnectOpen}
        mode={connectMode}
        setMode={setConnectMode}
        financeData={connectData}
        setFinanceData={setConnectData}
        submit={submit}
      />
      <NickName
        mode={formMode}
        selectedData={formData}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={submit}
      />
    </>
  );
};

export default BankAccountMapping;
